import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
export default {
  name: 'MdmLink',
  props: {
    url: {
      type: String,
      required: true
    },
    isNuxt: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    link: function link() {
      return _defineProperty({}, this.isNuxt ? 'to' : 'href', this.url);
    },
    component: function component() {
      return this.isNuxt ? 'nuxt-link' : 'a';
    }
  }
};